export enum ActionType {
  Sign = 'Sign',
  Edit = 'Edit',
  Delete = 'Delete',
  Download = 'Download',
}
